/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useLocation,  useSearchParams } from "react-router-dom";

import { GradientOverlay, MobileNav, PeopleList } from "@molecules";
import { Wall, Tributes, Repost, StoryFace } from "@organisms";
import { useIsMobile } from "hooks";

import { Container,  MainWrapper, ListWrapper, TributesWrapper } from "./people.styles";
import { StoriesDataProvider } from "contexts/StoriesContext";
import { StoryDataProvider, useStoryDataContext } from "contexts/StoryContext";
import { Skeleton } from "antd";
import { WallDataProvider } from "contexts/WallContext";
import { TributeNotificationsDataProvider } from "contexts/NotificationsContext";

export const People = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const {story, storyLoading, isCreator} = useStoryDataContext();
  const isMobile = useIsMobile(767);

  const tab = searchParams.get("tab");

  const isMyStory = location.pathname.startsWith("/my-stories");
  const wholeStory = isMyStory ? "my-stories" : "stories";

  const showMain = !isMobile || tab === "my-stories";

  return (
    <TributeNotificationsDataProvider>
      <GradientOverlay/>
      <Container>
        {showMain && (
          <ListWrapper>
            <PeopleList wholeStory={wholeStory}/>
          </ListWrapper>
        )}

        {showMain && (
          <MainWrapper>
            <StoryFace/>
            {story && !storyLoading && (
              <WallDataProvider storyId={story.uuid} isCreator={isCreator}>
                <Wall/>
              </WallDataProvider>
            )}
          </MainWrapper>
        )}

        <TributesWrapper>
          {storyLoading && <Skeleton.Node active style={{width: 360, height: 440}}/>}
          {!storyLoading && story && (
            <>
              <Repost name={story.name}/>
              <Tributes/>
            </>
          )}
        </TributesWrapper>
        {isMobile && <MobileNav/>}
      </Container>
    </TributeNotificationsDataProvider>
  );
};

const PeopleWrapper = () => {
  return (
    <StoriesDataProvider>
      <StoryDataProvider>
        <People/>
      </StoryDataProvider>
    </StoriesDataProvider>
  );
};

export const MyPeopleWrapper = () => {
  return (
    <StoriesDataProvider isMy>
      <StoryDataProvider>
        <People/>
      </StoryDataProvider>
    </StoriesDataProvider>
  );
};

export default PeopleWrapper;
